import React from "react";
import styled from "styled-components";

import MainHeading from "./MainHeading";
import MainForm from "./MainForm";

export const MainWrap = styled.div`
  flex: 1;
  margin: 0 auto;
  max-width: 58rem;
  display: ${props => (props.isHidden ? "none" : "block")};
`;

const MainInitial = ({ setFormSuccess, isHidden }) => (
  <MainWrap isHidden={isHidden}>
    <MainHeading />
    <MainForm setFormSuccess={setFormSuccess} />
  </MainWrap>
);

export default MainInitial;
